import jwt_decode from 'jwt-decode';

const obtenerRolesDelToken = (token) => {
  const decoded = jwt_decode(token);
  return decoded;
};

export default obtenerRolesDelToken;
